module.exports = __webpack_public_path__ + "img/PRO QR-code.1816773e.png";